import { escapeHtml } from 'tools/tools';

export type SupportAdmin = { email?: string; display_name?: string };

/**
 * The parameter values are user-controlled text and are escaped here; the template is admin markup, so callers still
 * mount the result through sanitizeHtml. Replacer functions keep `$&`-style sequences in a query literal.
 */
export function fillThemeSystemMessage(template: string, searchQuery: string, supportAdmins: SupportAdmin[]): string {
    const query = escapeHtml(searchQuery ?? '');
    const admins = (supportAdmins ?? [])
        .map((user) => `<a href="mailto:${escapeHtml(user.email ?? '')}">${escapeHtml(user.display_name ?? '')}</a>`)
        .join(', ');

    return (template ?? '').replaceAll('[SearchQuery]', () => query).replaceAll('[SupportAdmin]', () => admins);
}
